import React from "react";
import { FaceCapture } from "@/components/kyc/FaceCapture";
import { legacyUploadAdapter } from "./legacyUploadAdapter";

export function LegacyFaceCaptureAdapter({
  session,
  completedAttempts = 0,
  onComplete,
  onClearError,
}) {
  const orderDetail = session?.orderDetail || session?.order || session || {};

  return (
    <FaceCapture
      isFirstSubmitFace={completedAttempts}
      orderDetail={orderDetail}
      ssn={legacyUploadAdapter.getUploadKey(session)}
      onComplete={onComplete}
      clearError={onClearError}
      autoStart
    />
  );
}
